import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE4Items = getItem('FE4', 'FE4', <FolderOutlined />, [
  getItem('FE4 1st Gen Editor', 'FE4/1stGenEditor'),
  getItem('FE4 2nd Generation Static Character Editor 1', 'FE4/2ndGenerationStaticCharacterEditor1'),
  getItem('FE4 2nd Generation Static Character Editor 2', 'FE4/2ndGenerationStaticCharacterEditor2'),
  getItem('FE4 2nd Generation Static Character Editor 3', 'FE4/2ndGenerationStaticCharacterEditor3'),
  getItem('FE4 Army Editor', 'FE4/ArmyEditor'),
  getItem('FE4 Army Pointer Editor', 'FE4/ArmyPointerEditor'),
  getItem('FE4 Battle Music Editor', 'FE4/BattleMusicEditor'),
  getItem('FE4 Battle Sprite Editor', 'FE4/BattleSpriteEditor'),
  getItem('FE4 Battle Sprite Position Editor', 'FE4/BattleSpritePositionEditor'),
  getItem('FE4 Battle Sprite Position Editor 2', 'FE4/BattleSpritePositionEditor2'),
  getItem('FE4 Broken Weapon Editor', 'FE4/BrokenWeaponEditor'),
  getItem('FE4 Chapter Intro Music Editor', 'FE4/ChapterIntroMusicEditor'),
  getItem('FE4 Chapter Music Editor', 'FE4/ChapterMusicEditor'),
  getItem('FE4 Chapter Music Editor 2', 'FE4/ChapterMusicEditor2'),
  getItem('FE4 Char Name Editor (base $39C59)', 'FE4/CharNameEditorbase39C59'),
  getItem('FE4 Char Portrait Editor', 'FE4/CharPortraitEditor'),
  getItem('FE4 Character Skill Table Editor', 'FE4/CharacterSkillTableEditor'),
  getItem('FE4 Children Definition', 'FE4/ChildrenDefinition'),
  getItem('FE4 Children Editor 1 (Celice/Leaf)', 'FE4/Leaf'),
  getItem('FE4 Children Editor 2 (Altenna)', 'FE4/ChildrenEditor2Altenna'),
  getItem('FE4 Children Editor 3', 'FE4/ChildrenEditor3'),
  getItem('FE4 Circlet Editor', 'FE4/CircletEditor'),
  getItem('FE4 Class Editor', 'FE4/ClassEditor'),
  getItem('FE4 Class Name Editor (base $38CB3)', 'FE4/ClassNameEditorbase38CB3'),
  getItem('FE4 Class Skill Table Editor', 'FE4/ClassSkillTableEditor'),
  getItem('FE4 Classes Portrait Editor', 'FE4/ClassesPortraitEditor'),
  getItem('FE4 Custom Battle Palette Editor', 'FE4/CustomBattlePaletteEditor'),
  getItem('FE4 Enemy Editor 1', 'FE4/EnemyEditor1'),
  getItem('FE4 Enemy Editor 10', 'FE4/EnemyEditor10'),
  getItem('FE4 Enemy Editor 11', 'FE4/EnemyEditor11'),
  getItem('FE4 Enemy Editor 12', 'FE4/EnemyEditor12'),
  getItem('FE4 Enemy Editor 13', 'FE4/EnemyEditor13'),
  getItem('FE4 Enemy Editor 14', 'FE4/EnemyEditor14'),
  getItem('FE4 Enemy Editor 15', 'FE4/EnemyEditor15'),
  getItem('FE4 Enemy Editor 16', 'FE4/EnemyEditor16'),
  getItem('FE4 Enemy Editor 17', 'FE4/EnemyEditor17'),
  getItem('FE4 Enemy Editor 18', 'FE4/EnemyEditor18'),
  getItem('FE4 Enemy Editor 19', 'FE4/EnemyEditor19'),
  getItem('FE4 Enemy Editor 2', 'FE4/EnemyEditor2'),
  getItem('FE4 Enemy Editor 20', 'FE4/EnemyEditor20'),
  getItem('FE4 Enemy Editor 21', 'FE4/EnemyEditor21'),
  getItem('FE4 Enemy Editor 22', 'FE4/EnemyEditor22'),
  getItem('FE4 Enemy Editor 23', 'FE4/EnemyEditor23'),
  getItem('FE4 Enemy Editor 24', 'FE4/EnemyEditor24'),
  getItem('FE4 Enemy Editor 25', 'FE4/EnemyEditor25'),
  getItem('FE4 Enemy Editor 26', 'FE4/EnemyEditor26'),
  getItem('FE4 Enemy Editor 27', 'FE4/EnemyEditor27'),
  getItem('FE4 Enemy Editor 28', 'FE4/EnemyEditor28'),
  getItem('FE4 Enemy Editor 29', 'FE4/EnemyEditor29'),
  getItem('FE4 Enemy Editor 3', 'FE4/EnemyEditor3'),
  getItem('FE4 Enemy Editor 4', 'FE4/EnemyEditor4'),
  getItem('FE4 Enemy Editor 5', 'FE4/EnemyEditor5'),
  getItem('FE4 Enemy Editor 6', 'FE4/EnemyEditor6'),
  getItem('FE4 Enemy Editor 7', 'FE4/EnemyEditor7'),
  getItem('FE4 Enemy Editor 8', 'FE4/EnemyEditor8'),
  getItem('FE4 Enemy Editor 9', 'FE4/EnemyEditor9'),
  getItem('FE4 Hair Color Editor', 'FE4/HairColorEditor'),
  getItem('FE4 Holy Blood Editor', 'FE4/HolyBloodEditor'),
  getItem('FE4 Holy Character Editor 1', 'FE4/HolyCharacterEditor1'),
  getItem('FE4 Holy Character Editor 10', 'FE4/HolyCharacterEditor10'),
  getItem('FE4 Holy Character Editor 11', 'FE4/HolyCharacterEditor11'),
  getItem('FE4 Holy Character Editor 12', 'FE4/HolyCharacterEditor12'),
  getItem('FE4 Holy Character Editor 13', 'FE4/HolyCharacterEditor13'),
  getItem('FE4 Holy Character Editor 14', 'FE4/HolyCharacterEditor14'),
  getItem('FE4 Holy Character Editor 15', 'FE4/HolyCharacterEditor15'),
  getItem('FE4 Holy Character Editor 16', 'FE4/HolyCharacterEditor16'),
  getItem('FE4 Holy Character Editor 17', 'FE4/HolyCharacterEditor17'),
  getItem('FE4 Holy Character Editor 18', 'FE4/HolyCharacterEditor18'),
  getItem('FE4 Holy Character Editor 19', 'FE4/HolyCharacterEditor19'),
  getItem('FE4 Holy Character Editor 2', 'FE4/HolyCharacterEditor2'),
  getItem('FE4 Holy Character Editor 3', 'FE4/HolyCharacterEditor3'),
  getItem('FE4 Holy Character Editor 4', 'FE4/HolyCharacterEditor4'),
  getItem('FE4 Holy Character Editor 5', 'FE4/HolyCharacterEditor5'),
  getItem('FE4 Holy Character Editor 6', 'FE4/HolyCharacterEditor6'),
  getItem('FE4 Holy Character Editor 7', 'FE4/HolyCharacterEditor7'),
  getItem('FE4 Holy Character Editor 8', 'FE4/HolyCharacterEditor8'),
  getItem('FE4 Holy Character Editor 9', 'FE4/HolyCharacterEditor9'),
  getItem('FE4 Holy Character Leptor', 'FE4/HolyCharacterLeptor'),
  getItem('FE4 Holy Weapon Flash Editor', 'FE4/HolyWeaponFlashEditor'),
  getItem('FE4 Holy Weapon Flash Editor (Modified)', 'FE4/HolyWeaponFlashEditorModified'),
  getItem('FE4 Item Editor', 'FE4/ItemEditor'),
  getItem('FE4 Item Name Editor (base $3DE12)', 'FE4/ItemNameEditorbase3DE12'),
  getItem('FE4 Item Skill Table Editor', 'FE4/ItemSkillTableEditor'),
  getItem('FE4 Item Sprite Editor', 'FE4/ItemSpriteEditor'),
  getItem('FE4 Love Bases - 1st Generation', 'FE4/LoveBases1stGeneration'),
  getItem('FE4 Love Conversations', 'FE4/LoveConversations'),
  getItem('FE4 Love Growths -  2nd Generation', 'FE4/LoveGrowths2ndGeneration'),
  getItem('FE4 Love Growths - 1st Generation', 'FE4/LoveGrowths1stGeneration'),
  getItem('FE4 Loves Bases -  2nd Generation', 'FE4/LovesBases2ndGeneration'),
  getItem('FE4 Magic Animation Editor', 'FE4/MagicAnimationEditor'),
  getItem('FE4 Magic Animation Pointer Editor (base 17917D, up to 0x4C)', 'FE4/MagicAnimationPointerEditorbase17917Dupto0x4C'),
  getItem('Fe4 Map Sprite Editor', 'FE4/Fe4MapSpriteEditor'),
  getItem('FE4 Player Weapon Editor', 'FE4/PlayerWeaponEditor'),
  getItem('FE4 Promotion Editor', 'FE4/PromotionEditor'),
  getItem('FE4 Ring Editor', 'FE4/RingEditor'),
  getItem('FE4 Shield Definition Editor', 'FE4/ShieldDefinitionEditor'),
  getItem('FE4 Shield Sprite Editor', 'FE4/ShieldSpriteEditor'),
  getItem('FE4 Shop Editor - Chapter 1 & 2', 'FE4/ShopEditorChapter12'),
  getItem('FE4 Shop Editor - Chapter 10', 'FE4/ShopEditorChapter10'),
  getItem('FE4 Shop Editor - Chapter 3', 'FE4/ShopEditorChapter3'),
  getItem('FE4 Shop Editor - Chapter 4', 'FE4/ShopEditorChapter4'),
  getItem('FE4 Shop Editor - Chapter 6', 'FE4/ShopEditorChapter6'),
  getItem('FE4 Shop Editor - Chapter 7', 'FE4/ShopEditorChapter7'),
  getItem('FE4 Shop Editor - Chapter 8', 'FE4/ShopEditorChapter8'),
  getItem('FE4 Shop Editor - Chapter 9', 'FE4/ShopEditorChapter9'),
  getItem('FE4 Sibling Bonus Editor', 'FE4/SiblingBonusEditor'),
  getItem('FE4 Skill Display Editor 1 (Stat Screen)', 'FE4/SkillDisplayEditor1StatScreen'),
  getItem('FE4 Skill Display Editor 2 (Stat Screen Description)', 'FE4/SkillDisplayEditor2StatScreenDescription'),
  getItem('FE4 Skill Display Editor 3 (Skill List Description)', 'FE4/SkillDisplayEditor3SkillListDescription'),
  getItem('FE4 Terrain Movement Cost Editor', 'FE4/TerrainMovementCostEditor'),
  getItem('FE4 Triangle Attack Editor', 'FE4/TriangleAttackEditor'),
  getItem('FE4 Weapon Bonus Editor', 'FE4/WeaponBonusEditor'),
  getItem('FE4 Weapon/Staff Editor 1', 'FE4/StaffEditor1'),
  getItem('FE4 Weapon/Staff Editor 2', 'FE4/StaffEditor2'),
]);

export default FE4Items;
